const buildConditionalsWithAgreement = screen => {
  return screen.conditionals.map(conditional => {
    const agreementField = conditional.fields.find(
      field =>
        field.name === "agreements" &&
        field.params.includes("TDFieldOptionIsAgreement")
    );
    return !agreementField
      ? conditional
      : {
          ...conditional,
          fields: [
            {
              ...agreementField,
              name: "agreements.accepted"
            }
          ]
        };
  });
};

export default buildConditionalsWithAgreement;
